import { list as getList } from "~/api/contractBackupStoragePlan";
import * as types from "../mutation-types";
import store from "../../store";
import { entityStoreStatus } from "~/mixins/entityStoreStatus";

export const state = {
  list: null,
  isLoading: false,
  isInitialLoadPending: true
};

/**
 * Mutations
 */
export const mutations = {
  [types.SET_IS_LOADING_CONTRACT_BACKUP_STORAGE_PLAN](state, status) {
    state.isLoading = status;
  },
  [types.SET_CONTRACT_BACKUP_STORAGE_PLAN](state, contractStorage) {
    state.list = contractStorage.data;
    state.isInitialLoadPending = false;
  }
};

/**
 * Actions
 */
export const actions = {
  fetchContractBackupStoragePlan({ commit }, contractId = null) {
    commit(types.SET_IS_LOADING_CONTRACT_BACKUP_STORAGE_PLAN, true);

    let activeContractId =
      contractId || store.getters["contract/activeContract"]?.id;

    if (activeContractId) {
      getList(activeContractId).then((response) => {
        let { data } = response;
        commit(types.SET_CONTRACT_BACKUP_STORAGE_PLAN, data);
        commit(types.SET_IS_LOADING_CONTRACT_BACKUP_STORAGE_PLAN, false);
      });
    }
  }
};

/**
 * Getters
 */
export const getters = {
  list: (state) => state.list,
  isLoading: (state) => state.isLoading,
  isInitialLoadPending: (state) => state.isInitialLoadPending,
  ...entityStoreStatus.getters
};
